export default {
  namespaced: true,
  state: {
    items: {
      locale: "en",
      img: require("@/assets/images/flags/en.png"),
      name: "English",
    },
    showLoginLoading: false
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getLoginLoading(state) {
      return state.showLoginLoading;
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    updateLoginLoading(state, value) {
      state.showLoginLoading = value;
    },
  },
};
